import axios from 'axios';
import cookies from 'react-cookies'

const token = cookies.load("_mkdtoken");

const Axios = axios.create({
  headers: {
    "Authorization": "bearer " + token
  }
});

// axiosInstance.interceptors.request.use((config) => {

// })

// axiosInstance.interceptors.response.use((response) => {
  
// })

export default Axios;


// WEBPACK FOOTER //
// ./src/views/services/instance.js